const STAGE_CLASSES: Record<string, string> = {
  Basisplan: 'bg-blue-50 text-td-blue',
  Planning: 'bg-purple-50 text-purple-600',
  Drukattest: 'bg-amber-50 text-amber-600',
  Collectoren: 'bg-emerald-50 text-emerald-600',
  // Sale order states
  Verkooporder: 'bg-emerald-50 text-emerald-600',
  Offerte: 'bg-amber-50 text-amber-600',
  'Offerte verzonden': 'bg-blue-50 text-td-blue',
  Geupload: 'bg-emerald-50 text-emerald-600',
  Goedgekeurd: 'bg-blue-50 text-td-blue',
  Gevorderd: 'bg-violet-50 text-violet-700',
  Geannuleerd: 'bg-red-50 text-red-600',
  Vergrendeld: 'bg-gray-100 text-gray-600',
  // Materiaal project stages
  Backlog: 'bg-gray-100 text-gray-700',
  'Actief Project': 'bg-blue-100 text-blue-700',
  'Einde Werken': 'bg-green-100 text-green-700',
};

export function getStageClasses(stage: string): string {
  return STAGE_CLASSES[stage] ?? 'bg-gray-100 text-gray-600';
}
